<template>
    <div class="dailiInfo-wrap">
       <el-form :model="zfbForm" label-width="100px">
            <el-form-item label="支付宝名称：">
                <el-input v-model="zfbForm.name" style="width: 300px;"></el-input>
            </el-form-item>
            <el-form-item label="支付宝账号：">
                <el-input v-model="zfbForm.account" style="width: 300px;"></el-input>
            </el-form-item>
       </el-form>
       <el-button type="primary">确认</el-button>
    </div>
</template>

<script>
import ChannelApi from '@/api/channel.js';
export default {
    props:{
        dailiInfo:{
            type:Object,
            default:{}
        }
    },
    data(){
        return{
            zfbForm:{
                name:'',
                account:''
            }
        }
    },
    created(){
        this.zfbForm = {
                    name:this.dailiInfo.data && this.dailiInfo.data.zfbname || '未知',
                    account:this.dailiInfo.data && this.dailiInfo.data.zfbaccount || '未知'
                }
    },
    methods:{
        
    }

}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/views/channel/user/daili/account.vue